import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, input, output, signal, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataObject, Interval, SubscriptionPlans } from '@app/_shared/interfaces';
import { FontAwesomeImportModule } from '@app/_shared/material/font-awesome-import.module';
import { ButtonModule } from 'primeng/button';
import { CarouselModule, CarouselResponsiveOptions } from 'primeng/carousel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayBadge } from 'primeng/overlaybadge';
import { PanelModule } from 'primeng/panel';
import { SelectButton } from 'primeng/selectbutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'sb-plans',
  templateUrl: './plans.component.html',
  imports: [
    CommonModule,
    FontAwesomeImportModule,

    // PrimeNG
    LayoutModule,
    ButtonModule,
    ToggleSwitchModule,
    CarouselModule,
    PanelModule,
    InputTextModule,
    FloatLabelModule,
    SelectButton,
    FormsModule,
    OverlayBadge,
  ],
})
export class PlansComponent {
  readonly headerTemplate = input<TemplateRef<any> | null>(null);
  readonly plans = input<DataObject<SubscriptionPlans>[]>();
  readonly selectedPlanId = input<number | null>(null);
  readonly currentPlanId = input<number | null, number>(null, {
    transform: (value) => {
      return this.updateIntervalFromPlan(value);
    },
  });
  readonly loading = input(false);

  readonly selectPlan = output<number>();

  subscriptionInterval = signal<Interval>('month');

  subscriptionIntervalOptions = [
    { label: 'Måned', value: 'month' },
    { label: 'År', value: 'year' },
  ];

  responsiveOptions: CarouselResponsiveOptions[] = [
    { breakpoint: '4000px', numVisible: 5.5, numScroll: 1 },
    { breakpoint: '2560px', numVisible: 4.5, numScroll: 1 },
    { breakpoint: '1920px', numVisible: 3.5, numScroll: 1 },
    { breakpoint: '1440px', numVisible: 2.5, numScroll: 1 },
    { breakpoint: '1280px', numVisible: 1.5, numScroll: 1 },
    { breakpoint: '768px', numVisible: 2.5, numScroll: 1 },
  ];

  private updateIntervalFromPlan(value: number) {
    if (this.plans() === undefined) return value;
    const plan = this.plans().find((plan) => plan.id === value);
    if (plan === undefined) return value;
    this.subscriptionInterval.set(this.plans().find((plan) => plan.id === value).attributes.interval);
    return value;
  }

  isPlanInCurrentInterval(interval: Interval): boolean {
    return this.plans()?.some((plan) => plan.attributes.interval === interval && plan.id === this.selectedPlanId());
  }

  onSelectPlan(planId: number) {
    this.selectPlan.emit(planId);
  }

  getFilteredPlans(interval): DataObject<SubscriptionPlans>[] {
    return this.plans()?.filter((plan) => plan.attributes.interval === interval);
  }
}
